import { definitionsFromContext } from "stimulus/webpack-helpers"
import application from "init/stimulus"

const context = require.context('.', true, /_controller\.js$/)
application.load(definitionsFromContext(context))
